<template>
    <div style="max-height:835px;" class="h-100">
        <div
            v-if="(imageID || escriptID)"
            id="prescription-image-component"
            style="resize:both; z-index:100;" class="h-100">
            <!-- Showing PDF -->
            <div v-show="!imageSrc" :id="pdfContainerID" class="no-image h-100">
                <!-- Default message if PDF file was not found -->
                <h2>File not found</h2>
            </div>

            <!-- IMAGE FOUND -->
            <b-img v-if="imageSrc" style="overflow:auto; height:100%;" :src="imageSrc" fluid thumbnail/>
        </div>
        <!-- No image has been loaded. -->
        <div v-else-if="!rxNumber">
            <div class="no-image">
                <h4><i>No RX Loaded</i></h4>
            </div>
        </div>
        <div v-else>
            <div class="no-image">
                <h4><i>No image loaded in this prescription.</i></h4>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    import PDFObject from "pdfobject";
    import Axios, { AxiosResponse } from 'axios';
    import { Component, Prop, Vue, Watch } from "vue-facing-decorator";

    @Component({
        name: "ImageComponent",
    })
    export default class ImageComponent extends Vue {
        @Prop() private imageID!: number;
        @Prop() private escriptID!: number;
        @Prop() private rxNumber!: number;

        private imageSrc?: any = null;

        get pdfContainerID(): string {
            return 'pdf_' + this.imageID;
        }

        created(): void {
            console.log("%c Created ImageComponent", "color: green;");
            console.log(this.imageID);
            console.log(this.escriptID);
            if (this.imageID)
                this.fetchPrescriptionImageSource(`api/image/${this.imageID}`);
            else if (this.escriptID)
                this.fetchPrescriptionImageSource(`api/image/escript/${this.escriptID}`);
        }

        beforeDestroy(): void {
            console.log('%c Destroying ImageComponent', 'color: red');
        }

        @Watch('imageID')
        imageIDUpdated(value: number): void {
            if (value)
                this.fetchPrescriptionImageSource(`api/image/${value}`);
        }

        @Watch('escriptID')
        escriptIDUpdated(value: number): void {
            if (value) {
                this.fetchPrescriptionImageSource(`api/image/escript/${value}`);
            }
        }

        fetchPrescriptionImageSource(imageUrl?: string): void {
            if (imageUrl) {

                this.imageSrc = null;
                Axios.get(imageUrl).then((response: AxiosResponse<any>) => {
                    const url = response.request.responseURL;
                    Axios.get(url, { responseType: "blob" }).then(r => {
                        const objectUrl = URL.createObjectURL(r.data);
                        if (response.headers["content-type"] == "application/pdf") {
                            // noinspection SpellCheckingInspection
                            const options = {
                                pdfOpenParams: {
                                    pagemode: 'thumbs',
                                    scrollbar: 0,
                                    toolbar: 1,
                                    view: 'FitW',
                                },
                            };
                            PDFObject.embed(objectUrl, '#' + this.pdfContainerID, options);
                        } else {
                            this.imageSrc = objectUrl;
                        }
                        this.$nextTick(() => {
                            this.$forceUpdate();
                        });
                    });
                });
            }
        }

    }
</script>

<style scoped>

</style>
